import _ from "lodash";
import { SelectOption } from "components/dropdown/Dropdown";
import { DispatchedSurveyTriggerProps } from "./DispatchedSurveyTrigger.types";

export const useDispatchedSurveyTrigger = ({
  parsedData,
  setParsedData,
  referenceData,
  setReferenceData,
}: Pick<
  DispatchedSurveyTriggerProps,
  "parsedData" | "setParsedData" | "referenceData" | "setReferenceData"
>) => {
  const handleChangeSurveyTemplate = (option: SelectOption | null) => {
    const newValue = option ? option.value : null;

    const newParsedData: any = _.cloneDeep(parsedData);
    if (newParsedData) {
      newParsedData.surveyTemplatesID = newValue;
      setParsedData(newParsedData);
    }

    const newReferenceData = _.cloneDeep(referenceData);
    if (newReferenceData?.trigger) {
      newReferenceData.trigger.surveyTemplatesID = newValue;
    }
    setReferenceData(newReferenceData);
  };

  const handleChangeProject = (options: SelectOption[]) => {
    const newValue = options ? options.map((item) => item.value) : null;

    const newParsedData: any = _.cloneDeep(parsedData);
    if (newParsedData) {
      newParsedData.projectTypesIDs = newValue;
      setParsedData(newParsedData);
    }

    const newReferenceData = _.cloneDeep(referenceData);
    if (newReferenceData?.trigger) {
      newReferenceData.trigger.projectTypesIDs = newValue;
    }
    setReferenceData(newReferenceData);
  };

  return { handleChangeSurveyTemplate, handleChangeProject };
};
